import React, { FC } from 'react';
import styled from 'styled-components';
import { Price } from 'shared-types/Common';
import { useTranslations } from '@lang';
import { Price as PriceComponent } from '@common/components/Price';

const Wrapper = styled.div`
  padding: ${({ theme }) => theme.spaces.space1} 0;
  font-weight: normal;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
`;

type PricePerNightProps = {
  totalPrice?: Price;
  numGuests: number;
};

export const PricePerCover: FC<PricePerNightProps> = ({ totalPrice, numGuests }) => {
  const { t } = useTranslations();

  if (!totalPrice) {
    return null;
  }

  const { currencyCode, amount: totalAmount } = totalPrice;
  const amount = totalAmount / numGuests;

  return (
    <Wrapper>
      {t('tables.pricePerCover', {
        pricePerCover: <PriceComponent price={{ currencyCode, amount }} />,
      })}
    </Wrapper>
  );
};
